/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { AuthenticationStrictHttpResponse } from '../../authentication-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SocialAccountModel } from '../../models/social-account-model';

export interface LocalAccountLinkedSocialAccountGet$Params {
}

export function localAccountLinkedSocialAccountGet(http: HttpClient, rootUrl: string, params?: LocalAccountLinkedSocialAccountGet$Params, context?: HttpContext): Observable<AuthenticationStrictHttpResponse<Array<SocialAccountModel>>> {
  const rb = new RequestBuilder(rootUrl, localAccountLinkedSocialAccountGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as AuthenticationStrictHttpResponse<Array<SocialAccountModel>>;
    })
  );
}

localAccountLinkedSocialAccountGet.PATH = '/LocalAccount/LinkedSocialAccount';
